/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import GroupMemberList from './GroupMemberList';

const propTypes = {
    groupMembers: PropTypes.arrayOf(PropTypes.shape({})),
    altGroupLeaders: PropTypes.arrayOf(PropTypes.shape({})),
    maxAlternateLeaders: PropTypes.number,
    maxMemberQuota: PropTypes.number,
    launchDetail: PropTypes.shape({
        entryDate: PropTypes.object,
        exitDate: PropTypes.object,
    }),
    handleGroupMemberChange: PropTypes.func,
    validation: PropTypes.shape({}),
    isDisabled: PropTypes.bool,
    issuance: PropTypes.object,
    division: PropTypes.object.isRequired,
    permit: PropTypes.object.isRequired,
};

const defaultProps = {
    isDisabled: false,
};

export default class GroupMemberDetail extends React.Component {
    render() {
        return (
            <GroupMemberList
                permit={this.props.permit}
                division={this.props.division}
                maxMemberQuota={this.props.maxMemberQuota}
                entryDate={this.props.launchDetail.entryDate}
                exitDate={this.props.launchDetail.exitDate}
                groupMembers={this.props.groupMembers}
                maxAlternateLeaders={this.props.maxAlternateLeaders}
                altGroupLeaders={this.props.altGroupLeaders}
                handleGroupMemberChange={this.props.handleGroupMemberChange}
                issuance={this.props.issuance}
                validation={this.props.validation}
                isDisabled={this.props.isDisabled}
            />
        );
    }
}

GroupMemberDetail.propTypes = propTypes;
GroupMemberDetail.defaultProps = defaultProps;
